import { createContext, useContext, useState } from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import CloseIcon from '@mui/icons-material/Close';
import { settingsRowClass, SettingsRowInner } from './SettingsRow';
// Lets a nested form (e.g. PublisherSettingsSection) close its own dialog after a successful save.
const SettingsDialogCloseContext = createContext(() => { });
export const useSettingsDialogClose = () => useContext(SettingsDialogCloseContext);
const overlayClass = 'fixed inset-0 z-[1102] bg-black/80 data-[state=open]:animate-dialog-overlay-show data-[state=closed]:animate-dialog-overlay-hide';
const contentClass = 'redesign dark-scrollbar fixed left-1/2 top-1/2 z-[1103] max-h-[calc(100vh_-_2rem)] w-[calc(100%_-_2rem)] max-w-md -translate-x-1/2 -translate-y-1/2 overflow-y-auto '
    + 'glass border-white/[0.08] p-6 text-foreground shadow-2xl shadow-black/40 sm:rounded-2xl '
    + 'data-[state=open]:animate-dialog-content-show data-[state=closed]:animate-dialog-content-hide';
// A settings list row that opens its form in a nested dialog (instead of navigating away).
export const SettingsDialogRow = ({ label, description, Icon, title, children }) => {
    const [open, setOpen] = useState(false);
    return (<DialogPrimitive.Root open={open} onOpenChange={setOpen}>
			<DialogPrimitive.Trigger asChild>
				<button type="button" className={settingsRowClass}>
					<SettingsRowInner label={label} description={description} Icon={Icon}/>
				</button>
			</DialogPrimitive.Trigger>
			<DialogPrimitive.Portal>
				<DialogPrimitive.Overlay className={overlayClass}/>
				<DialogPrimitive.Content className={contentClass}>
					<DialogPrimitive.Title className="sr-only">{title}</DialogPrimitive.Title>
					<SettingsDialogCloseContext.Provider value={() => setOpen(false)}>
						{children}
					</SettingsDialogCloseContext.Provider>
					<DialogPrimitive.Close className="absolute right-4 top-4 z-10 rounded-sm text-muted-foreground opacity-70 transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-muted-foreground focus:ring-offset-2">
						<CloseIcon sx={{ fontSize: 16 }}/>
						<span className="sr-only">Close</span>
					</DialogPrimitive.Close>
				</DialogPrimitive.Content>
			</DialogPrimitive.Portal>
		</DialogPrimitive.Root>);
};
